/* eslint-disable guard-for-in */
/* eslint-disable complexity */
/* eslint-disable max-len */
import React, { useState, useEffect, useCallback } from 'react';
// import moment from 'moment';
// import Createable from 'react-select';
import axios from 'axios';
// import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
// const AsyncTypeahead = asyncContainer(Typeahead);
// import Loader from '../Common/Loader';
import constants from '../../constants';
import { cookieStorageUtility } from '../../utils/utilityFunctions';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const ManageRoomComponent = ({ room_category_id, history, setNoticeMessage, setUILoaderVisibility }) => {
  const [categoryDetails, setCategoryDetails] = useState({
    room_category_id: '',
    room_category_type: '0',
    room_category_sub: '',
    room_category_name: '',
    category_code: '',
    base_occupancy: 1,
    no_extra_bed: 0,
    no_kid: 0,
    room_category_description: '',
    total_rooms: '',
    linked_with: 0,
    taxes: []
  });

  const [otherData, setOtherData] = useState({
    room_category_types: {},
    room_category_sub: {},
    room_bed_type: {},
    taxes: [],
    apply_linked_with: false,
    non_linked_room_category: {}
  });

  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [masterCategoryList, setMasterCategoryList] = useState([]);

  const getRoomTypeCommonData = useCallback(() => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setUILoaderVisibility(true);

    axios(serverUrl + 'category/commonaccomodationdata', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        requestdata: {
          taxes: 1,
          room_category_types: 1,
          room_category_sub: 1,
          non_linked_room_category: 1
        }
      }
    })
      .then(response => {
        setUILoaderVisibility(false);
        if (response.data.status === 'success') {
          setOtherData(prevState => ({
            ...prevState,
            taxes: response.data.responsedata.taxes4ui,
            room_category_types: response.data.responsedata.room_category_types,
            room_category_sub: response.data.responsedata.room_category_sub_key_by_code,
            room_bed_type: response.data.responsedata.room_bed_type,
            non_linked_room_category: response.data.responsedata.non_linked_room_category_by_id
          }));
        } else {
          setNoticeMessage(response.data.message, 'error');
        }
      })
      .catch(error => {
        console.log(error);
        setUILoaderVisibility(false);
      });
  }, []); // Remove dependencies to prevent re-creation

  const getMasterCategoryList = useCallback((data) => {
    setShowSearchLoader(true);
    axios(serverUrl + 'roomcategory/masterCategoryList', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { param: { limit: 10, category_name: data } }
    })
      .then(response => {
        if (response.data.status === 'success') {
          setMasterCategoryList(response.data.list);
        } else {
          setNoticeMessage(response.data.message, 'error');
        }
        setShowSearchLoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowSearchLoader(false);
      });
  }, [setNoticeMessage]);

  const handleSearch = useCallback((data) => {
    if (typeof data === 'undefined' || data === '') {
      return;
    }
    if (data.length > 2) {
      getMasterCategoryList(data);
    }
  }, [getMasterCategoryList]);

  const paramChange = useCallback((e, type) => {
    setCategoryDetails(prevState => ({
      ...prevState,
      category_code: e[0].category_code,
      room_category_id: e[0].category_id,
      room_category_name: e[0].category_name
    }));
  }, []);

  const handleInputChange = useCallback((e, obj) => {
    let numRegex = new RegExp('^[0-9]+$');
    let fillTargetValue = true;
    let updates = { [obj.name]: e.target.value };

    switch (obj.name) {
      case 'room_category_type':
        updates.room_category_sub = '';
        break;
      case 'room_category_sub':
        updates.room_category_name = e.target.value;
        break;
      case 'linked_with':
        let catId = parseInt(e.target.value);
        if (catId === 0) {
          updates.total_rooms = '';
          updates.base_occupancy = 0;
          updates.no_kid = 0;
        } else {
          let cDetail = otherData.non_linked_room_category[catId];
          updates.total_rooms = cDetail.total_rooms;
          updates.base_occupancy = cDetail.base_occupancy;
          updates.no_kid = cDetail.no_kid;
        }
        break;
      case 'total_rooms':
        if (e.target.value !== '' && numRegex.test(e.target.value) === false) {
          setNoticeMessage('Only number allow', 'error');
          fillTargetValue = false;
        }
        break;
      default:
        break;
    }

    if (fillTargetValue) {
      setCategoryDetails(prevState => ({
        ...prevState,
        ...updates
      }));
    }
  }, [otherData.non_linked_room_category, setNoticeMessage]);

  const manageCategory = useCallback(() => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    let msg = '';

    // check form validation
    if (categoryDetails['room_category_type'] === 0) {
      msg += 'Category Type is required.' + '<br />';
    } else if (categoryDetails['room_category_sub'] === '') {
      msg += 'Category Sub Type is required.' + '<br />';
    } else if (categoryDetails['room_category_name'] === '') {
      msg += 'Category Name is required.' + '<br />';
    } else if (categoryDetails['category_code'] === '') {
      msg += 'Category code is required.' + '<br />';
    }

    if (msg === '') {
      if (otherData['apply_linked_with']) {
        if (categoryDetails['linked_with'] === 0) {
          msg += 'Linked Room Category is required.' + '<br />';
        }
      } else {
        if (categoryDetails['total_rooms'] === '') {
          msg += 'No of Room is required.' + '<br />';
        }
      }
    }

    if (msg === '') {
      let requestdata = { request_type: 'new' };
      requestdata.data = categoryDetails;
      if (room_category_id) {
        requestdata.request_type = 'overlay';
        requestdata.data.room_category_id = room_category_id;
      }

      let url = '';
      if (room_category_id) {
        url = serverUrl + 'category/updatecategory';
      } else {
        url = serverUrl + 'category/createcategory';
      }

      setUILoaderVisibility(true);
      axios(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: {
          hotelId,
          requestdata
        }
      })
        .then(response => {
          setUILoaderVisibility(false);
          if (response.data.status === 'success') {
            if (room_category_id) {
              setNoticeMessage('Room Category has been updated', 'success');
            } else {
              setNoticeMessage('Room Category has been created', 'success');
            }
            history.push('/roomcategory');
          } else {
            setNoticeMessage(response.data.message, 'error');
          }
        })
        .catch(error => {
          console.log(error);
          setUILoaderVisibility(false);
        });
    } else {
      setNoticeMessage(msg, 'error');
    }
  }, [categoryDetails, otherData, room_category_id, setUILoaderVisibility, setNoticeMessage, history]);

  const getCategoryDetails = useCallback(() => {
    setUILoaderVisibility(true);
    const hotelId = cookieStorageUtility.fetch('hotelId');

    axios(serverUrl + 'category/getcategory', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        room_category_detail_id: room_category_id,
        hotelId
      }
    })
      .then(response => {
        setUILoaderVisibility(false);
        if (response.data.status === 'success') {
          setCategoryDetails(response.data.data);
          setOtherData(prevState => ({
            ...prevState,
            apply_linked_with: response.data.data.linked_with > 0
          }));
        } else {
          setNoticeMessage(response.data.message, 'error');
        }
      })
      .catch(error => {
        console.log(error);
        setUILoaderVisibility(false);
      });
  }, [room_category_id]); // Only room_category_id as dependency since it's the only one that should trigger re-fetch

  const handleTaxSelect = useCallback((e) => {
    setCategoryDetails(prevState => ({
      ...prevState,
      taxes: e && e.length > 0 ? e : []
    }));
  }, []);

  const handleLinkedWithCheckbox = useCallback((e) => {
    setOtherData(prevState => {
      const newApplyLinkedWith = !prevState.apply_linked_with;
      return {
        ...prevState,
        apply_linked_with: newApplyLinkedWith
      };
    });
    
    // Reset category details if unlinking
    setCategoryDetails(prevState => ({
      ...prevState,
      total_rooms: '',
      base_occupancy: 0,
      no_kid: 0,
      linked_with: 0
    }));
  }, []);

  useEffect(() => {
    // Load common data only once when component mounts
    getRoomTypeCommonData();
  }, []); // Empty dependency array - runs only once on mount

  useEffect(() => {
    // Load category details only when room_category_id changes
    if (room_category_id) {
      getCategoryDetails();
    }
  }, [room_category_id, getCategoryDetails]); // Only depends on room_category_id and getCategoryDetails

  let room_category_types = [];
  for (let i in otherData.room_category_types) {
    let data = otherData.room_category_types[i];
    room_category_types.push(
      <option value={data.room_category_code} key={i}>
        {data.room_category_name}
      </option>
    );
  }

  let room_category_sub = [];
  if (categoryDetails.room_category_type !== '0') {
    let rcs = otherData.room_category_sub[categoryDetails.room_category_type];
    for (let i in rcs) {
      let data = rcs[i];
      room_category_sub.push(
        <option value={data.subroom_name} key={i}>
          {data.subroom_name}
        </option>
      );
    }
  }
  let noKidHtml = [];
  for (let i = 0; i <= 5; i++) {
    noKidHtml.push(
      <option value={i} key={i}>
        {i}
      </option>
    );
  }
  let baseOccupancyHtml = [];
  for (let i = 1; i <= 50; i++) {
    baseOccupancyHtml.push(
      <option value={i} key={i}>
        {i}
      </option>
    );
  }
  let noExtraBedHtml = [];
  for (let i = 0; i <= 20; i++) {
    noExtraBedHtml.push(
      <option value={i} key={i}>
        {i}
      </option>
    );
  }
  let nonLinkedRoomCategoryListHtml = [];
  nonLinkedRoomCategoryListHtml.push(
    <option value={0} key={0}>
      Select
    </option>
  );
  if (Object.keys(otherData.non_linked_room_category).length > 0) {
    let d = otherData.non_linked_room_category;
    for (let i in d) {
      let data = d[i];
      if (data !== null && data.room_category_detail_id !== null && typeof data.room_category_detail_id !== 'undefined') {
        nonLinkedRoomCategoryListHtml.push(
          <option value={data.room_category_detail_id} key={data.room_category_detail_id}>
            {data.room_category_name}
          </option>
        );
      }
    }
  }

  return (
    <React.Fragment>
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 marg_bottom20 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">Add/Edit Category</div>
          </div>
        </div>
      </div>
      <div className="container_fluid pad_lft_rht30 text-start">
        <div className="container">
          <div className="wrapper">
            <div className="ovr marg_bottom20">
              <div className="row">
                <div className="col-xs-12 col-md-6">
                  <label className="ovr marg_bottom7 bld">
                    Type <span className="color5">*</span>
                  </label>
                  <div className="frm border_all_1 border_color_1 border_all_1 border_color_1border_all_1 border_color_1">
                    {' '}
                    <span className="ficon">
                      <i className="fa fa-chevron-down"></i>
                    </span>
                    <select
                      name=""
                      className="input pad_lft_rht10"
                      value={categoryDetails.room_category_type}
                      onChange={e => handleInputChange(e, { name: 'room_category_type' })}
                    >
                      <option value="0">Select</option>
                      {room_category_types}
                    </select>
                  </div>
                </div>
                <div className="col-xs-12 col-md-6">
                  <label className="ovr marg_bottom7 bld">
                    Sub Type <span className="color5">*</span>
                  </label>
                  <div className="frm border_all_1 border_color_1">
                    {' '}
                    <span className="ficon">
                      <i className="fa fa-chevron-down"></i>
                    </span>
                    <select
                      name=""
                      className="input pad_lft_rht10"
                      value={categoryDetails['room_category_sub']}
                      onChange={e => handleInputChange(e, { name: 'room_category_sub' })}
                    >
                      <option value="">Select</option>
                      {room_category_sub}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="ovr marg_bottom20">
              <div className="ovr marg_bottom10">
                <label className="ovr marg_bottom7 bld">
                  Name <span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht10"
                    value={categoryDetails['room_category_name']}
                    onChange={e => handleInputChange(e, { name: 'room_category_name' })}
                    maxLength="120"
                  />
                </div>
              </div>
            </div>

            {/* <div className="ovr marg_bottom20">
              <div className="ovr marg_bottom10">
                <label className="ovr marg_bottom7 bld">Name<span className="color5">*</span></label>
                <div className="frm border_all_1 border_color_1">
                  <AsyncTypeahead
                    ref={(typeahead) => this.typeahead = typeahead}
                    inputProps={ { className: '' } }
                    multiple={false}
                    isLoading={this.state.showSearchLoader}
                    options={this.state.masterCategoryList}
                    id= {`category_name`}
                    labelKey={'category_name'}
                    minLength={3}
                    align="justify"
                    onSearch={this.handleSearch}
                    placeholder={this.state.category_details.room_category_name}
                    filterBy={['category_name']}
                    selectHintOnEnter
                    onChange={(selected)=>{this.paramChange(selected, 'room_category_name')}}
                    defaultSelected={this.state.category_details.room_category_name}
                    renderMenuItemChildren={(option, props) => (<span
                      key={ option.category_id }
                      id={ option.category_id } >
                      { option.category_name }
                    </span>)}
                  />
                </div>
              </div>
            </div> */}

            <div className="ovr marg_bottom20">
              <div className="ovr marg_bottom10">
                <label className="ovr marg_bottom7 bld">
                  Category Code <span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht10"
                    value={categoryDetails['category_code']}
                    onChange={e => handleInputChange(e, { name: 'category_code' })}
                    maxLength="120"
                  />
                </div>
              </div>
            </div>

            <div className="ovr marg_bottom20">
              <div className="ovr marg_bottom10">
                <label className="ovr marg_bottom7 bld">
                  Occupancy <span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    name=""
                    className="input pad_lft_rht10"
                    value={categoryDetails['base_occupancy']}
                    onChange={e => handleInputChange(e, { name: 'base_occupancy' })}
                  >
                    {baseOccupancyHtml}
                  </select>
                </div>
              </div>
            </div>
            <div className="ovr marg_bottom20">
              <div className="ovr marg_bottom10">
                <label className="ovr marg_bottom7 bld">
                  No. of Extra Beds <span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    name=""
                    className="input pad_lft_rht10"
                    value={categoryDetails['no_extra_bed']}
                    onChange={e => handleInputChange(e, { name: 'no_extra_bed' })}
                  >
                    {noExtraBedHtml}
                  </select>
                </div>
              </div>
            </div>
            <div className="ovr marg_bottom20">
              <div className="ovr marg_bottom10">
                <label className="ovr marg_bottom7 bld">
                  No. of Kids <span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    name=""
                    className="input pad_lft_rht10"
                    value={categoryDetails['no_kid']}
                    onChange={e => handleInputChange(e, { name: 'no_kid' })}
                  >
                    {noKidHtml}
                  </select>
                </div>
              </div>
            </div>
            <div className="ovr marg_bottom20">
              <div className="ovr marg_bottom10">
                <label className="inline align_middle marg_bottom7 bld marg_right15">
                  No. of Rooms <span className="color5">*</span>
                </label>

                {/*<div className="inline align_middle marg_right3">
                  <input name="" type="checkbox" disabled={this.props.room_category_id} checked={this.state.other_data.apply_linked_with} onChange={(e)=>this.handleLinkedWithCheckbox(e)} />
                </div>
                <div className="inline align_top">Link Room With Other Category</div>*/}

                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht10"
                    value={categoryDetails['total_rooms']}
                    onChange={e => handleInputChange(e, { name: 'total_rooms' })}
                    maxLength="3"
                  />
                </div>
                {/*<div className={`frm border_all_1 border_color_1 ${this.state.other_data.apply_linked_with || this.props.room_category_id === 0?'hides':''}`}>
                  <div className="input pad_lft_rht10 padtop6">
                  {this.state.category_details['total_rooms']}
                  </div>
                </div>*/}

                <div
                  className={`frm border_all_1 border_color_1 ${
                    otherData.apply_linked_with ? '' : 'hides'
                  } ${room_category_id > 0 ? 'hides' : ''}`}
                >
                  <select
                    name=""
                    className="input pad_lft_rht10"
                    value={categoryDetails['linked_with']}
                    onChange={e => handleInputChange(e, { name: 'linked_with' })}
                  >
                    {nonLinkedRoomCategoryListHtml}
                  </select>
                </div>
                <div
                  className={`frm border_all_1 border_color_1 ${
                    otherData.apply_linked_with &&
                    room_category_id > 0 &&
                    categoryDetails.linked_with > 0
                      ? ''
                      : 'hides'
                  }`}
                >
                  <div className="input pad_lft_rht10 padtop6">
                    {typeof categoryDetails.linkedcategorydetails !== 'undefined'
                      ? categoryDetails.linkedcategorydetails.room_category_name
                      : ''}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="ovr marg_bottom20">
              <div className="ovr marg_bottom10">
                <label className="ovr marg_bottom7 bld">Taxes</label>
                <Createable
                  options={this.state.other_data.taxes}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  onChange={e => this.handleTaxSelect(e)}
                  value={this.state.category_details.taxes}
                />
              </div>
            </div> */}
            <div className="ovr marg_bottom20">
              <div className="ovr marg_bottom10">
                <label className="ovr marg_bottom7 bld">Description </label>
                <div className="frm border_all_1 border_color_1">
                  <textarea
                    name=""
                    cols=""
                    rows="10"
                    className="tera"
                    value={categoryDetails['room_category_description']}
                    maxLength="500"
                    onChange={e => handleInputChange(e, { name: 'room_category_description' })}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="ovr marg_bottom20 tr">
              <div
                className="inline btn1 pad_top_bot5 pad_lft_rht20 cursor_p fnt14"
                onClick={() => manageCategory()}
              >
                {room_category_id ? 'Update' : 'Create'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ManageRoomComponent;
